import data from "../../../../../packages/react/src/ButtonGroup/ButtonGroup.docs.json";
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  data,
  DeprecationBanner,
  React
};